<template>
    <div class="container">
        <div class="row justify-content-center text-center" :class="{'no-click-element': !parseInt(checkKit)}">
            <div class="col-12">
                <p class="bold text-green-dark fs-1-3 mt-2 mt-lg-5"><i>VIDEO LEZIONI</i></p>
                <h3 class="fs-2-7 mb-4">
                    Proietta in classe le video lezioni
                </h3>
            </div>
            <div class="col-12 col-xl-10 col-xxl-8 mb-2 mb-lg-5">
                <p>
                    I primi <strong>3 video</strong> trattano rispettivamente i temi dello <strong>“Stare Bene”</strong>,
                    <strong>“Scegliere Bene”</strong> e <strong>”Agire Bene”</strong>.
                    L’<strong>ultimo video</strong> propone di <strong>vivere in classe una pausa attiva</strong>,
                    attraverso uno “snack motorio” per <strong>ricaricare corpo e mente</strong>.
                </p>
            </div>
        </div>

        <!-- Videos -->
        <div class="row align-items-center my-5 py-4" :class="{'no-click-element': !parseInt(checkKit)}">
            <div class="col-md-6 pe-lg-4 pe-xl-5 my-3 order-2 order-md-1">
                <div class="video-responsive-vimeo w-100">
                    <iframe src="https://player.vimeo.com/video/1050095246" frameborder="0" allowfullscreen></iframe>
                </div>
            </div>
            <div class="col-md-6 ps-lg-4 ps-xl-5 my-3 order-1 order-md-2">
                <h3 class="fs-2-7">Condivisioni, emozioni e supporto tra pari</h3>
                <p class="text-green bold mb-4">A CURA DELLA DOTT.SSA LARA PELAGOTTI, PSICOTERAPEUTA</p>
                <p>
                    Cosa significa condividere? In quali <strong>modi</strong> possiamo farlo? E quali <strong>benefici</strong> otteniamo?
                    La dottoressa Pelagotti propone un approccio consapevole, fatto di <strong>ascolto attivo</strong> e
                    attività in classe per esercitare il supporto e la condivisione.
                </p>
                <div class="d-flex align-items-center">
                    <img :src="themaUrl + '/img/clessidra_red.svg'" width="44" height="55" alt="Durata video" class="img-fluid" loading="lazy">
                    <p class="ms-2 mb-0 fs-1-3 semibold text-secondary">
                        <i>7 minuti</i>
                    </p>
                </div>
            </div>
        </div>

        <div class="row align-items-center my-5 py-4" :class="{'no-click-element': !parseInt(checkKit)}">
            <div class="col-md-6 pe-lg-4 pe-xl-5 my-3">
                <h3 class="fs-2-7">Cibo e benessere: impariamo a fare scelte consapevoli</h3>
                <p class="text-green bold mb-4">A CURA DELLA DOTT.SSA SARA VITIELLO, BIOLOGA NUTRIZIONISTA</p>
                <p>
                    Il <strong>cibo è molto più di un bisogno</strong>: ci racconta chi siamo, ci dà energia per affrontare il presente e ci permette di costruire il nostro futuro,
                    all’insegna del benessere. La dottoressa Vitiello spiega come tutto ciò <strong>dipende anche dalle scelte che facciamo ogni giorno</strong>.
                </p>
                <div class="d-flex align-items-center">
                    <img :src="themaUrl + '/img/clessidra_red.svg'" width="44" height="55" alt="Durata video" class="img-fluid" loading="lazy">
                    <p class="ms-2 mb-0 fs-1-3 semibold text-secondary">
                        <i>5 minuti</i>
                    </p>
                </div>
            </div>
            <div class="col-md-6 ps-lg-4 ps-xl-5 my-3">
                <div class="video-responsive-vimeo w-100">
                    <iframe src="https://player.vimeo.com/video/1050094111" frameborder="0" allowfullscreen></iframe>
                </div>
            </div>
        </div>

        <div class="row align-items-center my-5 py-4" :class="{'no-click-element': !parseInt(checkKit)}">
            <div class="col-md-6 pe-lg-4 pe-xl-5 my-3 order-2 order-md-1">
                <div class="video-responsive-vimeo w-100">
                    <iframe src="https://player.vimeo.com/video/1050092786" frameborder="0" allowfullscreen></iframe>
                </div>
            </div>
            <div class="col-md-6 ps-lg-4 ps-xl-5 my-3 order-1 order-md-2">
                <h3 class="fs-2-7">Cibo, batteri e lotta allo spreco!</h3>
                <p class="text-green bold mb-4">A CURA DI MARCO MARTINELLI, DIVULGATORE SCIENTIFICO</p>
                <p>
                    Con Marco Martinelli impariamo a <strong>consumare solo il cibo di cui abbiamo bisogno</strong>, senza sprecare, e limitare così la nostra impronta sul Pianeta.
                </p>
                <div class="d-flex align-items-center">
                    <img :src="themaUrl + '/img/clessidra_red.svg'" width="44" height="55" alt="Durata video" class="img-fluid" loading="lazy">
                    <p class="ms-2 mb-0 fs-1-3 semibold text-secondary">
                        <i>6 minuti</i>
                    </p>
                </div>
            </div>
        </div>

        <div class="row align-items-center my-5 py-4" :class="{'no-click-element': !parseInt(checkKit)}">
            <div class="col-md-6 pe-lg-4 pe-xl-5 my-3">
                <h3 class="fs-2-7">Energia in movimento</h3>
                <p class="text-green bold mb-4">A CURA DI ANDREA PERICO, PERSONAL TRAINER ED EDUCATORE POSTURALE</p>
                <p>
                    Il movimento fisico riduce lo stress e migliora la concentrazione. Il personal trainer Andrea Perico propone una serie di esercizi da fare in classe per <strong>attivare il benessere del corpo e della mente!</strong>
                </p>
                <div class="d-flex align-items-center">
                    <img :src="themaUrl + '/img/clessidra_red.svg'" width="44" height="55" alt="Durata video" class="img-fluid" loading="lazy">
                    <p class="ms-2 mb-0 fs-1-3 semibold text-secondary">
                        <i>9 minuti</i>
                    </p>
                </div>
            </div>
            <div class="col-md-6 ps-lg-4 ps-xl-5 my-3">
                <div class="video-responsive-vimeo w-100">
                    <iframe src="https://player.vimeo.com/video/1050120794" frameborder="0" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['checkKit', 'themaUrl']
}
</script>

<style scoped>
.video-responsive-vimeo {
    overflow:hidden;
    padding-bottom:56.24%;
    position:relative;
    height:0;
}
.video-responsive-vimeo iframe{
    left:0;
    top:0;
    height:100%;
    width:100%;
    position:absolute;
    border: 1px solid #CECECE;
}
</style>
